const SECTIONS = [
  {
    h: "1. Introduction",
    p: "This Privacy Policy explains how It Is Established (\"the App\"), operated by War-Zone Global Ministry (\"we\", \"us\", \"our\"), collects, uses, and protects your information when you use our scripture decree generator. By using the App you agree to the practices described here.",
  },
  {
    h: "2. Information We Collect",
    p: "When you create an account we collect your name and email address. When you generate decrees we store the topics you enter and the decrees produced so you can revisit them in your history. We may also collect feedback you submit and, optionally, a profile picture and social profile links you choose to add. Guests may use the App without an account; in that case decrees are not saved.",
  },
  {
    h: "3. How We Use Your Information",
    p: "We use your information to provide and improve the App, to save and display your decree history, to respond to feedback, and to keep your account secure. Topics you enter are sent to our AI provider solely to generate scripture-based decrees.",
  },
  {
    h: "4. Third-Party Services",
    p: "We use trusted third-party providers to generate decrees and audio. These providers process the text you submit only to return results to you and do not use it to identify you personally. We do not sell your personal information.",
  },
  {
    h: "5. Data Security",
    p: "Passwords are stored using industry-standard one-way encryption (hashing). We take reasonable technical and organizational measures to protect your data, though no method of transmission or storage is completely secure.",
  },
  {
    h: "6. Your Rights",
    p: "You may delete saved decrees at any time from your history, and you may request deletion of your account and associated data by contacting us at admin@warzoneglobal.com.",
  },
  {
    h: "7. Children's Privacy",
    p: "The App is not directed to children under 13, and we do not knowingly collect personal information from them.",
  },
  {
    h: "8. Changes to This Policy",
    p: "We may update this Privacy Policy from time to time. Continued use of the App after changes constitutes acceptance of the revised policy.",
  },
  {
    h: "9. Contact",
    p: "For any questions about this Privacy Policy, contact War-Zone Global Ministry at admin@warzoneglobal.com.",
  },
];

export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-6 sm:px-8 pt-16 pb-24" data-testid="privacy-page">
      <p className="font-body text-sm uppercase tracking-[0.2em] text-[#7A756E]">Legal</p>
      <h1 className="font-heading text-4xl sm:text-5xl text-[#2C2A29] tracking-tight mt-3">Privacy Policy</h1>
      <p className="font-body text-sm text-[#7A756E] mt-4">Last updated: {new Date().toLocaleDateString()}</p>
      <div className="mt-10 space-y-8">
        {SECTIONS.map((s) => (
          <section key={s.h}>
            <h2 className="font-heading text-xl text-[#2C2A29] tracking-tight">{s.h}</h2>
            <p className="font-body text-base leading-relaxed text-[#4A4744] mt-2">{s.p}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
